import React, { Suspense, useState, useEffect, useRef } from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import Loader, { LoaderSearchImage } from "components/Loader";
import Header from "components/Header";
import HeaderMenu from "components/Genial/HeaderMenuContent";
import { OpenProvider } from "components/Genial/hooks/Open";
import { UserProvider as UserProviderGenial } from "components/Genial/hooks/UserContext";

import Routes from "routes";
import RoutesSafra from "./routesSafra";

import GlobalStylesLegacy from "globalStyle";
import WhitelabelThemeProvider from "theme/WhitelabelThemeProvider";
import GlobalStyles from "theme/GlobalStyles";
import { AuthProvider } from "contexts/AuthProvider";
import { AppProvider } from "contexts/AppContext";
import { GenialAppProvider } from "contexts/GenialAppContext";

import { AuthSafraProvider } from "contexts/Safra/AuthProvider";
import { EventsProvider } from "contexts/Safra/EventsProvider";

import ScrollToTop from "components/ScrollToTop";
import { urlChannel } from "utils";
import store from "store"
import config from "_config/config";

//Safra
import SafraHeader from "components/Safra/Header";

const mapWhitelabel = (wl) => {
    const theme = wl?.theme || {};
    const assets = wl?.assets || {};
    const mapped = {};
    if (theme.button_primary_color) {
        mapped.primary_color = theme.button_primary_color;
        mapped.button_primary_color = theme.button_primary_color;
    }
    if (theme.button_secondary_color) mapped.secondary_color = theme.button_secondary_color;
    if (theme.text_primary_color) {
        mapped.title_color = theme.text_primary_color;
        mapped.text_color = theme.text_primary_color;
    }
    if (theme.background_color) mapped.background_color = theme.background_color;
    if (theme.font_family) mapped.font_family = `'${theme.font_family}', sans-serif`;
    if (assets.name) mapped.page_title = assets.name;
    if (assets.favicon_url) mapped.favicon_url = assets.favicon_url;
    return mapped;
};

const MainContent = () => {
    urlChannel()

    const [whitelabelConfig, setWhitelabelConfig] = useState(null);
    const handshakeReceived = useRef(false);

    useEffect(() => {
        const handleMessage = (event) => {
            if (event?.data?.type !== 'AUTH_DATA') return;
            const wl = event.data?.payload?.whitelabel;
            if (!wl) return;
            const mapped = mapWhitelabel(wl);
            if (Object.keys(mapped).length) {
                handshakeReceived.current = true;
                setWhitelabelConfig(mapped);
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    // Fallback: se o handshake (AUTH_DATA da loja) nao trouxer o whitelabel,
    // busca direto no config MS pelo canal — mesma fonte usada nos textos
    // (TranslationContext). Garante o tema do canal mesmo sem a loja.
    useEffect(() => {
        const timer = setTimeout(() => {
            if (handshakeReceived.current) return;
            const channel = localStorage.getItem('channel');
            if (!channel) return;
            config.get(`whitelabels/byChannel/${channel}`)
                .then((response) => {
                    if (handshakeReceived.current) return;
                    const mapped = mapWhitelabel(response?.data?.data);
                    if (Object.keys(mapped).length) {
                        setWhitelabelConfig(mapped);
                    }
                })
                .catch(() => { /* mantem o tema default */ });
        }, 1200);
        return () => clearTimeout(timer);
    }, []);

    return (
        <WhitelabelThemeProvider whitelabel={whitelabelConfig}>
            <GlobalStyles />
            <GlobalStylesLegacy />
            {
                localStorage.getItem('channel') === 'genial' &&
            <AuthProvider>
                <AppProvider>
                    <Suspense fallback={<Loader/>}>
                        <Provider store={store}>
                            <GenialAppProvider>
                                <UserProviderGenial>
                                    <OpenProvider>
                                        <ScrollToTop />
                                        <HeaderMenu/>
                                        <Routes />
                                    </OpenProvider>
                                    <ToastContainer limit={1}/>
                                </UserProviderGenial>
                            </GenialAppProvider>
                        </Provider>
                    </Suspense>
                </AppProvider>
            </AuthProvider>
        }
        {
            localStorage.getItem('channel') === 'll' &&
                <AuthProvider>
                    <AppProvider>
                        <Suspense fallback={<LoaderSearchImage/>}>
                            <ScrollToTop />
                            <Header/>
                            <Routes/>
                        </Suspense>
                    </AppProvider>
                </AuthProvider>
        }
            {
                (localStorage.getItem('channel') === 'safra' || localStorage.getItem('channel') === 'encantech-shop') &&
                <EventsProvider>
                    <AuthSafraProvider>
                        <AppProvider>
                            <Suspense fallback={<LoaderSearchImage/>}>
                                <ScrollToTop />
                                {/*<SafraHeader />*/}
                                <RoutesSafra/>
                            </Suspense>
                        </AppProvider>
                    </AuthSafraProvider>
                </EventsProvider>
            }
        </WhitelabelThemeProvider>
    );
};

export default function App() {
    return <MainContent />
}
